import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import brandService from "../services/brandSerivce"

const brandsCollectionName = 'brands';
export const useBrands = () => {
  return useQuery({
    queryKey: [brandsCollectionName],
    queryFn: () => brandService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAddBrand = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: brandService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [brandsCollectionName] });
    },
  });
};

export const useEditBrand = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: brandService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [brandsCollectionName] });
    },
  });
};


export const useDeleteBrand = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: brandService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [brandsCollectionName] });
    },
  });
};

export const useDevisionBrands = (devisionId) => {
  return useQuery({
    queryKey: [brandsCollectionName, devisionId],
    queryFn: () => brandService.getDevisionBrands(devisionId),
    enabled: !!devisionId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useTeamsBrands = (teamId) => {
  return useQuery({
    queryKey: [brandsCollectionName, teamId],
    queryFn: () => brandService.getTeamsBrands(teamId),
    enabled: !!teamId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useBrandNameById = (brandId) => {
  return useQuery({
    queryKey: [brandsCollectionName, brandId],
    queryFn: () => brandService.getNameById(brandId),
    enabled: !!brandId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};




